import React from 'react';
import { MapPin } from 'lucide-react';
import { business, serviceAreas } from '../data/business';
export function ServiceArea() {
  return <section id="area" className="w-full bg-white py-16 lg:py-20" data-id="element-163" data-mp="ebi6zmn1u0zb">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-164" data-mp="s1byydtup1d9">
        <div className="rounded-3xl bg-brand-sky p-8 lg:p-12" data-id="element-165" data-mp="s2wsq18ccga2">
          <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:items-center lg:gap-12" data-id="element-166" data-mp="n8sin93s3s4r">
            <div data-id="element-167" data-mp="11xydylzhwy7d">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-teal" data-id="element-168" data-mp="11xexzateojvz">
                Service area
              </p>
              <h2 className="mt-3 font-display text-3xl leading-tight tracking-tight text-brand-navy sm:text-4xl" data-id="element-169" data-mp="1azo47ohn5r3k">
                {business.city.toUpperCase()} &amp; 30 MILES AROUND IT.
              </h2>
              <p className="mt-4 text-base text-brand-navy/70" data-id="element-170" data-mp="3cqrh6kf07hra">
                Not sure if you are in range? Call {business.phone} — if we can
                get there, we will clean it.
              </p>
            </div>
            <ul className="flex flex-wrap gap-2.5" data-id="element-171" data-mp="1a8zy3wtpme6u">
              {serviceAreas.map(area => <li key={area} className="inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-2 text-sm font-semibold text-brand-navy ring-1 ring-brand-navy/10" data-id="element-172" data-mp="1f833xjhikofv">
                  <MapPin className="h-3.5 w-3.5 text-brand-blue" aria-hidden="true" data-id="element-173" data-mp="1oy5uze52rsbk" />
                  {area}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}